import { createSlice } from '@reduxjs/toolkit';

const cohortSlice = createSlice({
  name: 'cohort',
  initialState: {
    count:0,
    limit:0,
    records:[]
  },
  reducers: {
    addCohort: (state, action) => {
      return action.payload
    }
  },
});

export const { addCohort } = cohortSlice.actions;
export default cohortSlice.reducer;
